export enum Environments {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production'
}
